import axios from "axios";
import { auth } from "constants/endpoints";

const refreshToken = ({ refreshToken }) => {
  const refreshTokenEndpoint = auth.refreshToken();
  const { REACT_APP_API_BASE_URL: API_BASE_URL } = process.env;
  const url = `${API_BASE_URL}${refreshTokenEndpoint}`;

  return axios(url, {
    method: "post",
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: { refreshToken }
  });
};

export default refreshToken;
